<template>
  <div>
    <template v-if="me.role == null">
      <div style="height: 500px; width: 500px; background-color: transparent">
        &nbsp;{{ me }}
      </div>
    </template>
    <template v-else-if="me.role === $roles.FOREIGNER">
      <ForeignerDashboard />
    </template>
    <template v-else>
      <Foreigners />
    </template>
  </div>
</template>

<script>
import { authComputed } from '@/vuex/helpers';
import { mapState } from 'vuex';
import ForeignerDashboard from '@/components/Foreigner/ForeignerDashboard';
import Foreigners from '@/views/admin/foreigners/Foreigners';

export default {
  components: {
    ForeignerDashboard,
    Foreigners,
  },
  computed: {
    ...authComputed,
    ...mapState({
      me: (state) => {
        console.log(state.v2.shared.profile.me);
        return state.v2.shared.profile.me;
      },
    }),
  },
};
</script>
